var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2237 1H0.755016C0.685494 1.00526 0.620571 1.0361 0.573276 1.08633C0.52598 1.13656 0.49981 1.20247 0.500016 1.27083V2.16667C0.499378 2.25849 0.517366 2.34951 0.552935 2.43446C0.588504 2.5194 0.640943 2.59656 0.707204 2.66146L7.0822 8.91146V14.1198L10.9338 16V8.90104L17.3087 2.65104C17.4307 2.52207 17.499 2.35296 17.5 2.17708V1.27083C17.5 1.199 17.4709 1.13012 17.4191 1.07933C17.3673 1.02853 17.297 1 17.2237 1Z",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/FilterIcon.349efdb976434fe1c1601204d004331e.svg";
export { ForwardRef as ReactComponent };